import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './SideBar';
import { Outlet } from 'react-router-dom';
import useWindowDimentions from './hooks/useWindowDimentions'

const UserLayout = (props) => {

    const [openbar, setOpenbar] = useState(true);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const { width, height } = useWindowDimentions();

    return (
        <div className="d-flex flex-column vh-100">
            <Header
                mobileMenuOpen={mobileMenuOpen}
                setMobileMenuOpen={setMobileMenuOpen}
            />
            <div className="d-flex flex-column flex-lg-row position-relative layout">
                {
                    mobileMenuOpen &&
                    <div className='d-block d-lg-none position-sticky pt-3 bg-backcolor mobile-sidebar-wrapper'>
                        <Sidebar
                            openbar={!openbar}
                            setOpenbar={setOpenbar}
                            setMobileMenuOpen={setMobileMenuOpen}
                        />
                    </div>
                }
                <div className='border-end border-info d-none d-lg-block position-fixed vh-100 pt-3 bg-backcolor sidebar-fixed'
                    style={
                         openbar ? {
                            width: '4.5rem',
                        }
                        : {
                            width: '12.875rem',
                        }}
                >
                    <Sidebar
                        openbar={openbar}
                        setOpenbar={setOpenbar}
                    />


                </div>
                <div className="overflow-y-auto overflow-x-hidden bg-backcolor"
                    ref={props.scrollRef}
                    style={
                        width < 992 ? {
                            marginLeft: 0,
                            minWidth: 0,
                            width: '100%',
                            } :
                        openbar ? {
                            marginLeft: '4.5rem',
                            minWidth: 0,
                            width: 'calc(100% - 4.5rem)',
                        }
                        : {
                            minWidth: 0,
                            width: 'calc(100% - 12.875rem)',
                            marginLeft: '12.875rem'
                        }
                    }
                >
                    <Outlet
                        context={{ openbar:openbar }}
                        scrollRef={props.scrollRef}
                    />
                </div>

            </div>
        </div>
    );
};

export default UserLayout;
